import {DialogFragment, DialogFragmentProps, DialogFragmentState} from "../shared/PageFragment";
import React, {ReactElement} from "react";
import {StyledBoxColumn, StyledBoxRow, StyledSpan} from "../shared/StyledComponents";
import {DIVIDER_BLACK, PAGE_FRAGMENT_LG_WIDTH, PD_LG} from "../shared/dimens";
import {Button, Grid, Typography} from "@mui/material";
import {BaseApp} from "../shared/BaseApp";

export class GalleryHelper {

  static showGallery(onCodeSet: (code: string) => void): void {
    BaseApp.CONTEXT.showDialog(null, () => <GalleryFragment
      onCodeSet={code => {
        BaseApp.CONTEXT.hideDialog();
        onCodeSet(code);
      }}
    />);
  }
}

type GalleryFragmentProps = DialogFragmentProps & {
  onCodeSet: (code: string) => void,
}

type GalleryFragmentState = DialogFragmentState & {
  selectedIndex: number,
}

type GalleryItem = {
  text: string,
  thumbnailUrl: string,
  code: string,
}

const GALLERY_ITEMS: GalleryItem[] = [
  {
    text: "Hexagon",
    thumbnailUrl: "/assets/gallery/hexagon.png",
    code: "REPEAT 6\n" +
      "  FD 50\n" +
      "  RT 60\n" +
      "END",
  },
  {
    text: "Star",
    thumbnailUrl: "/assets/gallery/star.png",
    code: "REPEAT 5\n" +
      "  FD 50\n" +
      "  RT 144\n" +
      "  FD 50\n" +
      "  RT 288\n" +
      "END",
  },
  {
    text: "Flower",
    thumbnailUrl: "/assets/gallery/flower.png",
    code: "REPEAT 8\n" +
      "  REPEAT 4\n" +
      "    FD 50\n" +
      "    RT 30\n" +
      "  END\n" +
      "  REPEAT 7\n" +
      "    FD 10\n" +
      "    RT 15\n" +
      "  END\n" +
      "END",
  },
];

class GalleryFragment extends DialogFragment<GalleryFragmentProps, GalleryFragmentState> {

  protected onCreateState(): GalleryFragmentState {
    return {
      ...super.onCreateState(),
      selectedIndex: -1,
    };
  }

  private renderInContainer(title: string, children: ReactElement): ReactElement {
    return <StyledBoxColumn style={{padding: PD_LG,}}>
      <Typography><b>{title}</b></Typography>
      {children}
    </StyledBoxColumn>;
  }

  renderContent(): ReactElement {
    return <StyledBoxColumn style={{width: "90vw", maxWidth: PAGE_FRAGMENT_LG_WIDTH, gap: 0}}>
      <StyledBoxRow style={{padding: PD_LG, alignItems: "center", borderBottom: DIVIDER_BLACK}}>
        <Typography variant={"h5"}>Gallery</Typography>
      </StyledBoxRow>
      <StyledBoxColumn style={{padding: PD_LG}}>
        {this.renderInContainer("Select to Import Code", <Grid container>
          {GALLERY_ITEMS.map((item, index) => {
            return <Grid xs={6} md={3} style={{padding: PD_LG}}>
              <Button
                onClick={() => this.setState({selectedIndex: index})}
                color={"secondary"} variant={this.state.selectedIndex === index ? "contained" : null}
                style={{padding: 0, width: "100%"}}>
                <StyledBoxColumn style={{width: "100%", padding: PD_LG}}>
                  <img src={item.thumbnailUrl} style={{width: "100%", aspectRatio: 1}}/>
                  <Typography>{item.text}</Typography>
                </StyledBoxColumn>
              </Button>
            </Grid>
          })}
        </Grid>)}
      </StyledBoxColumn>
      <StyledBoxRow style={{padding: PD_LG, alignItems: "center", borderTop: DIVIDER_BLACK}}>
        <StyledSpan/>
        <Button
          disabled={this.state.selectedIndex < 0}
          onClick={() => this.props.onCodeSet(GALLERY_ITEMS[this.state.selectedIndex].code)}
          variant={"contained"}>Import</Button>
      </StyledBoxRow>
    </StyledBoxColumn>;
  }
}